// extracted by mini-css-extract-plugin
export default {"timerAnimation":"Timer_timerAnimation__b96Ed","timeText":"Timer_timeText__WSktH"};